import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import VueI18n from "vue-i18n";
import messages from "@/translations";
import VueOffline from "vue-offline";
import { Component } from "vue-property-decorator";
import Vue2TouchEvents from "vue2-touch-events";
import VueScrollTo from 'vue-scrollto';
import './registerServiceWorker'

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready // returns a Promise, the active SW registration
    .then((swreg) => {
      //ServiceWorkerRegistration
      Vue.prototype.$swreg = swreg as ServiceWorkerRegistration;
      console.log("serviceWorker Mobi", swreg);
    });
}

Vue.use(VueOffline);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(VueScrollTo);
Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: "",
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 100,
  longTapTimeInterval: 100,
});
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "fr", // set locale
  messages, // set locale messages
});
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);


new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
